export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const mainNav = $('.main-menu');
    const mainNavItems = mainNav.find('.menu-item-has-children');
    const arrowButton = `<button class="arrow-button">
                            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81798 0.939453L0.757324 2.00011L4.99996 6.24275L9.24261 2.00011L8.18195 0.939453L4.99996 4.12143L1.81798 0.939453Z" fill="#17244D"/>
                            </svg>
                        </button>`;
    let activeMenuItem;

    //burger
    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        // mainNav.find('> li').removeClass('active').show();
        // mainNav.find('> .menu-item-has-children').removeClass('active');
        e.preventDefault();
    });

    //append arrow and back buttons
    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        const linkText = $(item).find(' > a').text();
        const backButton = `<div class="back-button">
                                <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M6.70213 0L0 5.01124L6.70213 10V5.50562L18 5.50562V4.49438L6.70213 4.49438L6.70213 0Z" fill="#17244D"/>
                                </svg>
                                <button>Back to ${linkText}</button>
                            </div>`;
        $(menuList).prepend(backButton);
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
        }
    });

    //close menu
    function closeDropdown(e) {
        if (!mainNavItems.has(e.target).length > 0) {
            mainNavItems.removeClass('active');
            window.removeEventListener('click', closeDropdown);
        }
    }

    //show/hide menu
    $(document).on("click", mainNav, function (e) {
        const target = $(e.target);

        // if (target.closest('.menu-item-has-children > a').length) {
        //     e.preventDefault();
        // }

        // if (target.closest('.menu-item-has-children > a').length) {
        if (target.closest('.menu-item-has-children .arrow-button').length) {
            activeMenuItem = target.closest('.menu-item-has-children');
            if (body.hasClass('touch')) {
                if (!activeMenuItem.hasClass("active")) {
                    activeMenuItem.siblings().removeClass('active');
                    activeMenuItem.addClass("active");
                    window.addEventListener('click', closeDropdown);
                } else {
                    activeMenuItem.removeClass("active");
                    window.removeEventListener('click', closeDropdown);
                }
            }
        }

        if (target.closest('.back-button button').length) {
            $('.menu-item-has-children').removeClass('active');
            activeMenuItem.removeClass("active");
            activeMenuItem = activeMenuItem.closest('.menu-item-has-children.active');
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js